import { render, staticRenderFns } from "./CatalogDetailView.vue?vue&type=template&id=36cdcb5d&scoped=true"
import script from "./CatalogDetailView.vue?vue&type=script&lang=js"
export * from "./CatalogDetailView.vue?vue&type=script&lang=js"
import style0 from "./CatalogDetailView.vue?vue&type=style&index=0&id=36cdcb5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cdcb5d",
  null
  
)

export default component.exports